import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const videoPlayerDefaultVariants = {}
const videoPlayerCompoundVariants = []

const videoPlayerSlotNames = [
  [
    "root",
    "videoPlayer__root"
  ],
  [
    "shell",
    "videoPlayer__shell"
  ],
  [
    "mediaFrame",
    "videoPlayer__mediaFrame"
  ],
  [
    "chapterTimeSlider",
    "videoPlayer__chapterTimeSlider"
  ],
  [
    "chapterSegments",
    "videoPlayer__chapterSegments"
  ],
  [
    "chapterSegment",
    "videoPlayer__chapterSegment"
  ],
  [
    "previewBubble",
    "videoPlayer__previewBubble"
  ],
  [
    "previewImage",
    "videoPlayer__previewImage"
  ],
  [
    "previewLabel",
    "videoPlayer__previewLabel"
  ],
  [
    "transcript",
    "videoPlayer__transcript"
  ],
  [
    "transcriptCloseButton",
    "videoPlayer__transcriptCloseButton"
  ],
  [
    "transcriptCue",
    "videoPlayer__transcriptCue"
  ],
  [
    "transcriptCueContent",
    "videoPlayer__transcriptCueContent"
  ]
]
const videoPlayerSlotFns = /* @__PURE__ */ videoPlayerSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, videoPlayerDefaultVariants, getSlotCompoundVariant(videoPlayerCompoundVariants, slotName))])

const videoPlayerFn = memo((props = {}) => {
  return Object.fromEntries(videoPlayerSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const videoPlayerVariantKeys = [
  "transcriptCueActive"
]
const getVariantProps = (variants) => ({ ...videoPlayerDefaultVariants, ...compact(variants) })

export const videoPlayer = /* @__PURE__ */ Object.assign(videoPlayerFn, {
  __recipe__: false,
  __name__: 'videoPlayer',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: videoPlayerVariantKeys,
  variantMap: {
  "transcriptCueActive": [
    "true",
    "false"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, videoPlayerVariantKeys)
  },
  getVariantProps
})